/* Church Sign Shop — Contact page interactivity.
   - Topic chip selection (writes chosen topic into hidden input)
   - Optional client-side thank-you success panel (Shopify's own
     form.posted_successfully? state is rendered server-side too). */
(function () {
  function init() {
    var root = document.querySelector('[data-contact-form]');
    if (!root) return;

    /* ── Topic chips ──────────────────────────────────────────── */
    var chips = root.querySelectorAll('.contact-chip');
    var topicInput = root.querySelector('[data-topic-input]');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        if (topicInput) topicInput.value = chip.getAttribute('data-topic') || '';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
